var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconArrowRight(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'primary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { transform: "scale(4 4)" },
            React.createElement("g", { transform: "translate(3.000000, 9.000000)" },
                React.createElement("path", { d: "M13.3848 0L20 3.9455L13.3848 8V5.12976H0L0.0230486 2.74221L13.4076 2.75084L13.3848 0Z", fill: color })))));
}
//# sourceMappingURL=icon.arrow-right.component.js.map